export type HourSlot = {
    hour: number;
    dayLabel: string;
    timestamp: number;
    isWorkingHour: boolean;
    machineRunNames?: string[];
};

export type StepSpan = {
    stepId: string;
    stepName: string;
    departmentName: string;
    color: string;
    startSlotIndex: number;
    endSlotIndex: number;
    startTime: Date;
    endTime: Date;
    productionEndSlotIndex: number;
    machineStartSlotIndex: number | null;
    extendsBeforeView: boolean;
    extendsAfterView: boolean;
};

export type DepartmentGroup = {
    departmentName: string;
    steps: StepSpan[];
};

export type PlanOverviewResult = {
    hourSlots: HourSlot[];
    departmentGroups: DepartmentGroup[];
    orderDisplayId?: string;
    clinicName?: string;
    patientName?: string;
    currentHourSlotIndex?: number;
};

export const PROD_COLOR = '#1e88e5';
export const WAIT_COLOR = '#bdbdbd';
export const MACHINE_COLOR = '#812478';
export const BALL_SIZE = 8;
export const LINE_HEIGHT = 3;
